import '@babel/polyfill';
import 'whatwg-fetch';

import React from 'react';
import { createRoot } from 'react-dom/client';

// Paper
import { AppRoot } from '@nackle/deck';
import { Layout } from 'antd';
const { Content } = Layout;
import { getMiddleware as getRouteMiddleware, routes } from './app-routing.jsx';

// Routing
import { Route, Link, routeHistory } from '@nackle/biw-web-router';

import {
    ElevateHomeIcon,
    SlackLogo,
    DividerIcon,
    ElevateIcon
} from './components/shared/icons/icons.jsx';

import './styles/style.less';
const EZ_THANKS_TYPE = 'ezthanks';

class App extends React.Component {
    state = {
        activeType: location.pathname.split( '/' )[ 1 ] || 'slack'
    };

    render() {
        const {
            activeType
        } = this.state;
        return (
            <Route render={ ( route ) => (
                <AppRoot>
                    <Layout>
                        <header className="header">
                            <div className="wrapper">
                                <Link to={ `/${ activeType }` } className="logoTitleContainer"  >
                                    <ElevateHomeIcon />
                                </Link>
                                <div className="header-divider">
                                    <DividerIcon />
                                </div>
                                <div className="integrations-block slack-block">
                                    <SlackLogo />
                                </div>
                            </div>
                        </header>
                        <Content className="main-content">
                            {
                                route.match ? (
                                    route.component
                                ) : (
                                    null
                                )
                            }
                        </Content>
                    </Layout>
                    { activeType !== EZ_THANKS_TYPE && (
                        <div className="footer">
                            <div className="wrapper">
                                <div className="left-container">
                                    <ElevateIcon />
                                    <div className="links">
                                        <a href={ 'https://teams.elevate-platform.com/terms' }>
                                                Terms & Conditions
                                        </a>
                                        <a href={ 'https://teams.elevate-platform.com/privacy' }>
                                                Privacy Policy
                                        </a>
                                    </div>
                                </div>
                                <span className="copyright">
                                    { `©${ new Date().getFullYear() } BI Worldwide. All Rights Reserved.` }
                                </span>
                            </div>
                        </div>
                    ) }
                </AppRoot>
            ) } />
        );
    }

    handleClick = ( type ) => ( e ) => {
        e.preventDefault();

        this.setState( { activeType: type }, () => {
            routeHistory.push( `/${ type }` );
        } );
    };
}

routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( getRouteMiddleware() );

const root = createRoot( document.getElementById( 'app-root' ) );
root.render( <App /> );
